import { TopLevelMenuItem } from '../../utils/menu';

/** Full force-readback omnibar phrase (hint row label); selecting the hint triggers regular readback when OCB readback FF is on. */
export const FORCE_READBACK_OMNIBAR_INPUT = '/force-readback';

/** Minimum typed prefix (inclusive) for the force-readback omnibar hint to appear. */
export const FORCE_READBACK_OMNIBAR_PREFIX_MIN = '/force';

/** Synthetic omnibar option for force-readback hint; not a real menu item. */
export const FORCE_READBACK_HINT_MENU_ITEM_ID = '__force_readback_hint__';

export const FORCE_READBACK_HINT_CATEGORY_ID = 'force-readback-hint';

/** Synthetic omnibar dropdown row for force-readback hint; not a real menu item. */
export const FORCE_READBACK_HINT_MENU_ITEM: TopLevelMenuItem = {
  id: FORCE_READBACK_HINT_MENU_ITEM_ID,
  name: FORCE_READBACK_OMNIBAR_INPUT,
  category: FORCE_READBACK_HINT_CATEGORY_ID,
  categoryId: FORCE_READBACK_HINT_CATEGORY_ID,
  available: true,
  inactive: false,
};

export enum UpsellTriggers {
  hitlOmnibar = 'hitl_omnibar',
  hitlCenterPane = 'hitl_centerpane',
  hitlGreeting = 'hitl_greeting',
}
